import React from 'react';
import { useTranslation } from 'react-i18next';

import { getFaqLink } from 'helpers/getFaqLink';

import { Text } from 'components/library';

import * as S from './styled';

const SubscriptionHelpButton = () => {
    const { t } = useTranslation();

    return (
        <S.HelpButton>
            <Text type="medium-text" bold>
                {t('subscription.helpButton.question')}
            </Text>
            <S.FaqLink as="a" href={getFaqLink()} target="_blank" data-locator="faqButton">
                <Text type="caption" color="on-primary" bold>
                    {t('subscription.helpButton.faq')}
                </Text>
            </S.FaqLink>
        </S.HelpButton>
    );
};

export default SubscriptionHelpButton;
